import { type PropsWithChildren, useEffect } from 'react'
import { configureShareAnalytics } from './index'

export const ShareAnalyticsProvider = ({ children }: PropsWithChildren) => {
  useEffect(() => {
    configureShareAnalytics()
  }, [])

  return children as JSX.Element
}
